import {
    AgeSegmentRoomState,
    BookingState,
    CreditCardState,
} from '../../types/booking/BookingTypes';
import { TagColor } from '../../muiComponents/Tag';
import {
    headerColumnTypes,
    ITableHeaderColumn,
    sortDirections,
} from '../../types/lists/listTypes';

export const bookingFiltersSize = { xs: 12, sm: 6, md: 6, lg: 6, xl: 3 };
export const bookingDateFiltersSize = { xs: 12, sm: 6, md: 6, lg: 6, xl: 6 };
export const singleColumnGrid = { xs: 12, sm: 6, md: 6, lg: 6, xl: 3 };
export const doubleColumnGrid = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
export const imageColumnGrid = { xs: 6, sm: 6, md: 3, lg: 3, xl: 3 };

export const avatarColumnGrid = { xs: 12, sm: 6, md: 12, lg: 6, xl: 3 };
export const creditCardColumnGrid = { xs: 6, sm: 6, md: 6, lg: 6, xl: 3 };
export const pricesColumnGrid = { xs: 12, sm: 12, md: 12, lg: 12, xl: 3 };
export const taxNSupplementsColumnGrid = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 9,
};

/** Semantic Tag color per age segment. */
export const AGE_SEGMENT_COLOR: Record<AgeSegmentRoomState, TagColor> = {
    [AgeSegmentRoomState.ADULT]: 'purple',
    [AgeSegmentRoomState.CHILD]: 'orange',
    [AgeSegmentRoomState.BABY]: 'cyan',
};

export const OTA_REFERENCE_TABLE_CODE_KEY = '10';
export const PAYMENT_ACCOMPLISHED_KEY = 'PAYMENT_ACCOMPLISHED';

export const detailBookingInitialState: BookingState = {
    status: '',
    statusColor: '',
    isCancelled: false,
    idHotel: '',
    hotel: '',
    hotelImages: [],
    address: '',
    hotelRating: 0,
    hotelCategory: '',
    bookingCode: '',
    hotelRefecerenceCode: '',
    checkIn: null,
    checkOut: null,
    bookingDate: null,
    nights: 0,
    paxes: 0,
    customerName: '',
    totalAmount: 0,
    paymentId: 0,
    currency: '',
    notes: '',
    cancellationPolicies: [],
    rooms: [],
    paymentAmount: 0,
    paymentCurrency: '',
};

export const creditCardInitialState: CreditCardState = {
    creditCardHolderName: '',
    creditCardNumber: '',
    creditCardExpiryDate: '',
    cvc: '',
};

export const EMPTY_CREDIT_CARD_NUMBER = 'XXXXXXXXXXXXXXXX';

export const EMPTY_CREDIT_CARD_HOLDER_NAME = 'FASTPAY HOTELS';
export const EMPTY_CREDIT_CARD_EXPIRE_DATE = '--/--';

export const bookingListColumns: ITableHeaderColumn[] = [
    {
        id: 'SupplierBookingStatus/SupplierBookingStatusType/LocalizedCaption',
        labelText: 'status',
        titleText: 'status',
    },
    {
        id: 'BookingCode',
        labelText: 'booking_code',
        titleText: 'booking_code',
    },
    {
        id: 'SupplierHotel/Name',
        labelText: 'hotel',
        titleText: 'hotel',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'SupplierHotel/Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'BookingDate',
        labelText: 'booking_date',
        titleText: 'booking_date',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'BookingDate',
            defaultSortDir: sortDirections.DESC,
        },
    },
    {
        id: 'CheckInDate',
        labelText: 'check_in',
        titleText: 'check_in',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'CheckInDate',
            defaultSortDir: sortDirections.DESC,
        },
    },
    {
        id: 'CheckOutDate',
        labelText: 'check_out',
        titleText: 'check_out',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'CheckOutDate',
            defaultSortDir: sortDirections.DESC,
        },
    },
];
